// extracted by mini-css-extract-plugin
module.exports = {"scroll":"Success_scroll__3Hfxu","container":"Success_container__HYABa"};